import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Status colors and labels
export const packageStatusConfig = {
  received: { label: 'Reçu', color: 'bg-blue-100 text-blue-800', icon: 'Package' },
  processing: { label: 'En préparation', color: 'bg-yellow-100 text-yellow-800', icon: 'Settings' },
  shipped: { label: 'Expédié', color: 'bg-purple-100 text-purple-800', icon: 'Truck' },
  delivered: { label: 'Livré', color: 'bg-green-100 text-green-800', icon: 'CheckCircle' },
  returned: { label: 'Retourné', color: 'bg-red-100 text-red-800', icon: 'RotateCcw' },
};

export const countryNames = {
  FR: 'France',
  GP: 'Guadeloupe',
  MQ: 'Martinique',
  GF: 'Guyane',
  RE: 'Réunion',
  YT: 'Mayotte',
  NC: 'Nouvelle-Calédonie',
  PF: 'Polynésie française',
  DE: 'Allemagne',
  ES: 'Espagne',
  IT: 'Italie',
  BE: 'Belgique',
  NL: 'Pays-Bas',
  PT: 'Portugal',
  CH: 'Suisse',
  GB: 'Royaume-Uni',
  AT: 'Autriche',
  PL: 'Pologne',
  MA: 'Maroc',
  DZ: 'Algérie',
  TN: 'Tunisie',
  EG: 'Égypte',
  LY: 'Libye',
  SN: 'Sénégal',
  CI: "Côte d'Ivoire",
  CM: 'Cameroun',
  GA: 'Gabon',
  CG: 'Congo',
  CD: 'RD Congo',
  ML: 'Mali',
  BF: 'Burkina Faso',
  TG: 'Togo',
  BJ: 'Bénin',
  CN: 'Chine',
  JP: 'Japon',
  KR: 'Corée du Sud',
  VN: 'Vietnam',
  TH: 'Thaïlande',
  ID: 'Indonésie',
  MY: 'Malaisie',
  PH: 'Philippines',
  IN: 'Inde',
  US: 'États-Unis',
  CA: 'Canada',
  BR: 'Brésil',
  MX: 'Mexique',
  AR: 'Argentine',
  CL: 'Chili',
  CO: 'Colombie',
};

export const allCountries = Object.entries(countryNames).map(([code, name]) => ({
  code,
  name,
}));

export const formatDate = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount);
};
